<template>
  <div id="info-container">
      <p class="section-title">{{ $t('GenerateReport').toUpperCase() }}</p>
      <div>
        <div class="horizontal">
          <tr class="info-field-row">
            <td>
              <p class="info-field-title mb-1">{{ $t('WhichAlarmsPriorityChoose') }}</p>
            </td>
          </tr>
        </div>
        <div class="horizontal">
          <tr class="info-field-row">
            <td style="padding-right: 15px;">
              <p class="info-field-value mb-1">{{ $t('Priority') }} 1</p>
              <VueToggles :value="priority1Option" @click="priority1Option = !priority1Option" checkedBg="#0095b2" uncheckedBg="lightgrey" width="50" height="25"></VueToggles>
            </td>
            <td>
              <p class="info-field-value mb-1">{{ $t('Priority') }} 2</p>
              <VueToggles :value="priority2Option" @click="priority2Option = !priority2Option" checkedBg="#0095b2" uncheckedBg="lightgrey" width="50" height="25"></VueToggles>
            </td>
            <td style="padding-left: 15px;">
              <p class="info-field-value mb-1">{{ $t('Priority') }} 3</p>
              <VueToggles :value="priority3Option" @click="priority3Option = !priority3Option" checkedBg="#0095b2" uncheckedBg="lightgrey" width="50" height="25"></VueToggles>
            </td>
          </tr>
        </div>
        <div class="horizontal" style="padding-top: 20px;">
          <tr class="info-field-row">
            <td>
              <p class="info-field-title" style="margin-bottom: 5px;">{{ $t('ReportDate') }}</p>
              <datepicker :showTime="true" :dateFrom="dateFrom" :dateTo="dateTo" :min="new Date(-8640000000000000)" :max="new Date()" @dateChanged="dateChanged"></datepicker>
            </td>
          </tr>
        </div>
        <div class="horizontal" style="padding-top: 20px;">
          <tr class="info-field-row">
            <td>
              <p class="info-field-title" style="margin-bottom: 5px;">{{ $t('Devices') }}</p>
              <!-- <multiselect class="info-field-value" v-model="selectedDeviceOption" :options="devices" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" label="number" track-by="number" style="width: 250px; height: 35px; min-height: 35px;" :searchable="false" :option-height="35" :block-keys="['Tab', 'Enter']" select-label="" deselect-label="">
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }}/{{devices.length}} options selected</span>
                </template>
                <template slot="tag"><span class="custom__tag"></span></template>
                <template slot="option">
                </template>
              </multiselect> -->
              <devices-multiselect :system-id="systemObject.id" :pre-loaded-devices="devices" :pre-selected-devices="selectedDeviceOption" :date-from="dateFrom" :date-to="dateTo" @deviceChanged="(dev) => selectedDeviceOption = dev"></devices-multiselect>
            </td>
          </tr>
        </div>
        <div class="horizontal" style="padding-top: 20px;">
          <tr class="info-field-row" style="width: 250px;">
            <td class="info-field-value">
              <Button :title="$t('Cancel')" buttonClass='cancel-button semi-bold' style="width: 122px; align-self: center;" @onClick="cancel"></Button>
            </td>
            <td style="padding-left: 6px;" class="info-field-value">
              <Button :title="$t('Generate')" buttonClass='save-button semi-bold' style="width: 122px; align-self: center;" @onClick="generate"></Button>
            </td>
          </tr>
        </div>
      </div>
    </div>
</template>

<script>
import VueToggles from 'vue-toggles';
import Datepicker from '../Datepicker.vue';
import Button from '../Button.vue';
import { getPdfAlarmReportBySystemId, getSystemDevices } from '@/api/api'
import Vue from "vue";
import Multiselect from 'vue-multiselect'
import DevicesMultiselect from "../Filters/DevicesMultiselect";

export default {
  components: {
    Datepicker,
    VueToggles,
    Button,
    Multiselect,
    DevicesMultiselect
  },
  props: {
    systemObject: {
      type: Object,
      required: true
    }
  },
  data() {
    var dateWeekAgoTemp = new Date();
    dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7)
    dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate())

    return {
      dateFrom: dateWeekAgoTemp,
      dateTo: new Date(),
      priority1Option: false,
      priority2Option: false,
      priority3Option: false,
      devices: [],
      selectedDeviceOption: [],
      reportData: {
        systemId: '',
        DateFrom: null,
        DateTo: null,
        Priority: [],
        DevicesId: []
      }
    }
  },
  methods: {
    dateChanged(dateFrom, dateTo) {
      if(this.init == false){
          return;
      }
      this.dateFrom = dateFrom
      this.dateTo = dateTo
    },
    async getData() {
      // var data = await getSystemDevices(this.systemObject.id);
      // this.devices = Object.values(data).sort((a, b) => parseFloat(a.number) - parseFloat(b.number));
      // this.selectedDeviceOption = this.devices;
      // console.log(this.devices)
    },
    async generate() {
      let priorities = [];
      this.priority1Option == true ? priorities.push("1") : null;
      this.priority2Option == true ? priorities.push("2") : null;
      this.priority3Option == true ? priorities.push("3") : null;

      priorities.length == 0 ? priorities.push("0"): null;

      this.reportData.systemId = this.systemObject.id;
      this.reportData.DateFrom = this.dateFrom.toISOString();
      this.reportData.DateTo = this.dateTo.toISOString();
      this.reportData.Priority = priorities;
      this.reportData.DevicesId = this.selectedDeviceOption.map(a => a.id);

      let report = await getPdfAlarmReportBySystemId(this.reportData);
      let blob = new Blob([report.data], { type: 'application/pdf' });
      let url = window.URL.createObjectURL(blob);

      let fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.setAttribute('download', 'SampleRaport.pdf');
      document.body.appendChild(fileLink);
      fileLink.click();

      window.open(url);

      // this.$emit("cancel");
    },
    async cancel() {
      this.$emit("cancel");
    }
  },
  mounted() {
    this.getData();
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect__tags {
    min-height: 35px;
    height: 35px;
  }
  .multiselect__single {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #272727;
  }
</style>
<style scoped>

  .section-title {
    font-weight: bold;
  }

  #info-container {
    padding: 20px;
    border-radius: 5px 0px 0px 5px;
  }

  .info-field-title {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;

      color: #272727;
  }

  .info-field-row {
      width: 100%;
      margin: 0;
      padding-bottom: 5px;
      margin-right: 0px !important;
  }

  .info-field-value {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;

      color: #272727;
  }

</style>



// WEBPACK FOOTER //
// src/components/Systems/GenerateReportModal.vue